
import * as toasterTypes from '../constants/ActionTypes';
import * as userTypes from '../constants/userdetails';
import * as fileuploadAPI from '../api/fileupload';



export function fileUpload(objModel) {
    // console.log("fileUpload action call",objModel);
    return dispatch => {
        dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST });
        fileuploadAPI.fileUpload(objModel)
            .then(function (response) {
                // console.log("fileUpload action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_COMPLETED, data: response.data });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Uploaded Successfully" });
                }
                dispatch({ type: toasterTypes.UPLOAD_FILE_RESET });
            })
            .catch(function (err) {
                // console.log("fileUpload action err", err)
                dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_ERROR });
            });
    }
}

export function fileUploadcds(objModel) {
    // console.log("fileUpload action call",objModel);
    return dispatch => {
        dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST });
        fileuploadAPI.fileUploadcds(objModel)
            .then(function (response) {
                // console.log("fileUpload action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_COMPLETED, data: response.data });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Uploaded Successfully" });
                }
                dispatch({ type: toasterTypes.UPLOAD_FILE_RESET });
            })
            .catch(function (err) {
                // console.log("fileUpload action err", err)
                dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_ERROR });
            });
    }
}

export function photoUpload(objModel) {
    // console.log("photoUpload action call",objModel);
    return dispatch => {
        dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST });
        fileuploadAPI.photoUpload(objModel)
            .then(function (response) {
                // console.log("photoUpload action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_COMPLETED, data: response.data });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Uploaded Successfully" });
                }
                dispatch({ type: toasterTypes.UPLOAD_FILE_RESET });
            })
            .catch(function (err) {
                // console.log("photoUpload action err", err)
                dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_ERROR });
            });
    }
}

export function fileDownloadAgendaItem(objModel) {
    // console.log("fileDownloadAgendaItem action call",objModel);
    return dispatch => {
        dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST });
        fileuploadAPI.fileDownloadAgendaItem(objModel.fileId)
            .then(function (response) {
                // console.log("fileDownloadAgendaItem action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_COMPLETED });
                    // console.log(response)
                    let mimetype = getMIMEtype(objModel.type);
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: mimetype }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', objModel.fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                dispatch({ type: toasterTypes.UPLOAD_FILE_RESET });
            })
            .catch(function (err) {
                // console.log("fileDownloadAgendaItem action err", err)
                dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_ERROR });
            });
    }
}

export function fileDownloadCdsfiles(objModel, type, filename) {
    // console.log("fileDownloadCdsfiles action call",objModel);
    return dispatch => {
        dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST });
        fileuploadAPI.fileDownloadCdsfiles(objModel)
            .then(function (response) {
                // console.log("fileDownloadCdsfiles action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_COMPLETED });
                    // console.log(response)
                    let mimetype = getMIMEtype(type);
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: mimetype }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                }
                dispatch({ type: toasterTypes.UPLOAD_FILE_RESET });
            })
            .catch(function (err) {
                // console.log("fileDownloadCdsfiles action err", err)
                dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_ERROR });
            });
    }
}

export function fileDownloadResolution(objModel) {
    // console.log("fileDownloadResolution action call",objModel);
    return dispatch => {
        dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST });
        fileuploadAPI.fileDownloadResolution(objModel.fileId)
            .then(function (response) {
                // console.log("fileDownloadResolution action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_COMPLETED });
                    // console.log(response)
                    let mimetype = getMIMEtype(objModel.type);
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: mimetype }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', objModel.fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                dispatch({ type: toasterTypes.UPLOAD_FILE_RESET });
            })
            .catch(function (err) {
                // console.log("fileDownloadResolution action err", err)
                dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_ERROR });
            });
    }
}

export function fileDownloadEsignaturefiles(objModel) {
    // console.log("fileDownloadResolution action call",objModel);
    return dispatch => {
        dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST });
        fileuploadAPI.fileDownloadEsignaturefiles(objModel.fileId)
            .then(function (response) {
                // console.log("fileDownloadResolution action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_COMPLETED });
                    // console.log(response)
                    let mimetype = getMIMEtype(objModel.type);
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: mimetype }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', objModel.fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                dispatch({ type: toasterTypes.UPLOAD_FILE_RESET });
            })
            .catch(function (err) {
                // console.log("fileDownloadResolution action err", err)
                dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_ERROR });
            });
    }
}

export function fileDownloadArchivefiles(objModel) {
    // console.log("fileDownloadResolution action call",objModel);
    return dispatch => {
        dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST });
        fileuploadAPI.fileDownloadArchivefiles(objModel.fileId)
            .then(function (response) {
                // console.log("fileDownloadResolution action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_COMPLETED });
                    // console.log(response)
                    let mimetype = getMIMEtype(objModel.type);
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: mimetype }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', objModel.fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                dispatch({ type: toasterTypes.UPLOAD_FILE_RESET });
            })
            .catch(function (err) {
                // console.log("fileDownloadResolution action err", err)
                dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_ERROR });
            });
    }
}

export function photoDownload(objModel) {
    // console.log("photoDownload action call",objModel);
    return dispatch => {
        dispatch({ type: toasterTypes.DOWNLOAD_PHOTO_REQUEST });
        fileuploadAPI.photoDownload(objModel)
            .then(function (response) {
                // console.log("photoDownload action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.DOWNLOAD_PHOTO_REQUEST_COMPLETED, data: response.data && response.data.File ? response.data.File : null });
                }
            })
            .catch(function (err) {
                // console.log("photoDownload action err", err)
                dispatch({ type: toasterTypes.DOWNLOAD_PHOTO_REQUEST_ERROR });
            });
    }
}

export function photoDownloadLoggedInUser(objModel) {
    // console.log("photoDownload action call",objModel);
    return (dispatch, getState) => {
        // console.log('teamDetails', getState())
        let _state = getState()
        if (_state && _state.loginUser && _state.loginUser.loginUserPhoto) {
            // console.log('loadswitchercommittees loaded from CACHE')
        }
        else {
            dispatch({ type: userTypes.USER_PHOTO_REQUEST });
            fileuploadAPI.photoDownload(objModel)
                .then(function (response) {
                    // console.log("photoDownload action succ", response)
                    if (response.status == 200) {
                        dispatch({ type: userTypes.USER_PHOTO_REQUEST_COMPLETED, data: response.data && response.data.File ? response.data.File : -1 });
                    }
                })
                .catch(function (err) {
                    // console.log("photoDownload action err", err)
                    dispatch({ type: userTypes.USER_PHOTO_REQUEST_COMPLETED, data: -1 });
                });
        }
    }
}


export function fileDownloadMeetingMinutesFile(objModel) {
    // console.log("fileDownloadAgendaItem action call",objModel);
    return dispatch => {
        dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST });
        fileuploadAPI.fileDownloadMeetingMinutesFile(objModel.fileId)
            .then(function (response) {
                // console.log("fileDownloadAgendaItem action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_COMPLETED });
                    // console.log(response)
                    let mimetype = getMIMEtype(objModel.type);
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: mimetype }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', objModel.fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                dispatch({ type: toasterTypes.UPLOAD_FILE_RESET });
            })
            .catch(function (err) {
                // console.log("fileDownloadAgendaItem action err", err)
                dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_ERROR });
            });
    }
}

export function fileDownloadArchivedMeetingMinutesFile(objModel) {
    // console.log("fileDownloadAgendaItem action call",objModel);
    return dispatch => {
        dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST });
        fileuploadAPI.fileDownloadArchivedMeetingMinutesFile(objModel.id)
            .then(function (response) {
                // console.log("fileDownloadArchivedMeetingMinutesFile action succ", response)
                if (response.status == 200) {
                    dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_COMPLETED });
                    // console.log(response)

                    // console.log('file download url 11 ');

                    let mimetype = getMIMEtype(objModel.type);
                    // console.log('file download url 22 ');
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: mimetype }));
                    // console.log('file download url 33 ');
                    const link = document.createElement('a');
                    // console.log('file download url 44 ');
                    link.href = url;
                    // console.log('file download url ',url);
                    link.setAttribute('download', objModel.name);
                    document.body.appendChild(link);
                    link.click();
                }
                dispatch({ type: toasterTypes.UPLOAD_FILE_RESET });
            })
            .catch(function (err) {
                // console.log("fileDownloadAgendaItem action err", err)
                dispatch({ type: toasterTypes.UPLOAD_FILE_REQUEST_ERROR });
            });
    }
}

function getMIMEtype(extn) {
    let ext = extn.toLowerCase();
    let MIMETypes = {
        'txt': 'text/plain',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'doc': 'application/msword',
        'pdf': 'application/pdf',
        'jpg': 'image/jpeg',
        'bmp': 'image/bmp',
        'png': 'image/png',
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'rtf': 'application/rtf',
        'ppt': 'application/vnd.ms-powerpoint',
        'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    }
    return MIMETypes[ext];
}


// WEBPACK FOOTER //
// ./actions/fileupload.js